export const isElectron =
    typeof window !== 'undefined' && window.process && window.process.type === 'renderer';

export function isImg(url?: string) {
    if (!url) return false;
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'].includes(
        url?.split('.').pop()?.toLowerCase() ?? ''
    );
}
